import React from 'react';
import RcSlider from 'rc-slider';

const handle = (props, otherProps) => {
  const Handle = RcSlider.Handle;
  const { value, dragging, index, ...restProps } = props;
  const { hideStepLabel, unit } = otherProps;
  return (
    <div>
      <Handle value={value} {...restProps} />
      {!hideStepLabel ? (
        <div className="slider-thumb-value" style={{ left: value + '%' }}>
          {value}
          {unit ? unit : ''}
        </div>
      ) : null}
    </div>
  );
};

export default handle;
